'use client';

import { useState, useCallback } from 'react';
import { getDefaultDictionaryFile } from '@/lib/constants/vocabulary-categories';

export const useVocabularyPreview = () => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewData, setPreviewData] = useState<{
    dictionaryFile: string;
    categoryTitle: string;
  } | null>(null);

  const openPreview = useCallback((categoryId: string, categoryTitle: string) => {
    const dictionaryFile = getDefaultDictionaryFile(categoryId);
    setPreviewData({
      dictionaryFile,
      categoryTitle,
    });
    setIsPreviewOpen(true);
  }, []);

  const closePreview = useCallback(() => {
    setIsPreviewOpen(false);
    // Keep preview data for smooth closing animation
    setTimeout(() => {
      setPreviewData(null);
    }, 300);
  }, []);

  return {
    isPreviewOpen,
    previewData,
    openPreview,
    closePreview,
  };
};